import { createContext, useContext } from 'react';
import { enableStaticRendering } from 'mobx-react-lite';
import SIteTypesStore from '@features/footer/components/LanguageSelect/mobX/stores/SIteTypesStore';
enableStaticRendering(typeof window === 'undefined');
let store;
const initializeStore = () => {
  const newStore = store ?? new SIteTypesStore();
  if (typeof window === 'undefined') return newStore;
  if (!store) store = newStore;
  return newStore;
};
const SIteTypesStoreContext = createContext<SIteTypesStore>(initializeStore());
const useSIteTypesStore = () => useContext(SIteTypesStoreContext);
export { SIteTypesStore, useSIteTypesStore };